var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_56759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66663V2.49996M2.50008 9.99996H1.66675M4.58341 4.58329L4.08333 4.08321M15.4167 4.58329L15.917 4.08321M18.3334 9.99996H17.5001M8.33342 11.25H11.6667M10.0001 11.25V15.4166M12.9167 14.0616C14.1785 13.1539 15.0001 11.6729 15.0001 9.99996C15.0001 7.23854 12.7615 4.99996 10.0001 4.99996C7.23866 4.99996 5.00008 7.23854 5.00008 9.99996C5.00008 11.6729 5.82169 13.1539 7.08341 14.0616V15.6666C7.08341 16.6 7.08342 17.0668 7.26507 17.4233C7.42486 17.7369 7.67983 17.9918 7.99343 18.1516C8.34995 18.3333 8.81666 18.3333 9.75008 18.3333H10.2501C11.1835 18.3333 11.6502 18.3333 12.0067 18.1516C12.3203 17.9918 12.5753 17.7369 12.7351 17.4233C12.9167 17.0668 12.9167 16.6 12.9167 15.6666V14.0616Z",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_56759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.137cfcc0.svg";
export { ForwardRef as ReactComponent };